import DeviceData from 'Faster/model/DeviceData';

class Device {
  public readonly id: string;
  public readonly platform?: string;
  public readonly system?: string;
  public readonly systemVersion?: string;
  public readonly manufacturer?: string;
  public readonly deviceModel?: string;
  public readonly appVersion?: string;
  public readonly sdkVersion?: string;
  public readonly vendorId?: string;
  public readonly advertisingId?: string;
  public readonly pushToken?: string;
  public readonly cloudId?: string;
  public readonly carrierId?: string;
  public readonly timezone?: string;
  public readonly language?: string;
  public readonly isNewInstall?: boolean;
  public readonly properties?: object;

  public constructor(id: string, data: DeviceData) {
    this.id = id;
    this.platform = data.platform;
    this.system = data.system;
    this.systemVersion = data.systemVersion;
    this.manufacturer = data.manufacturer;
    this.deviceModel = data.deviceModel;
    this.appVersion = data.appVersion;
    this.sdkVersion = data.sdkVersion;
    this.vendorId = data.vendorId;
    this.advertisingId = data.advertisingId;
    this.pushToken = data.pushToken;
    this.cloudId = data.cloudId;
    this.carrierId = data.carrierId;
    this.timezone = data.timezone;
    this.language = data.language;
    this.isNewInstall = data.isNewInstall;
    this.properties = data.properties;
  }

  public withUpdatedPushToken(newToken: string): Device {
    const device = Object.create(Device.prototype);

    return Object.assign(device, this, {
      pushToken: newToken,
    });
  }

  public withAddedProperties(newProperties: object): Device {
    const updatedProperties = Object.assign({}, this.properties, newProperties);
    const device = Object.create(Device.prototype);

    return Object.assign(device, this, {
      properties: updatedProperties,
    });
  }

  public withRemovedProperty(name: string): Device {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updatedProperties: any = Object.assign({}, this.properties);
    const device = Object.create(Device.prototype);

    delete updatedProperties[name];

    return Object.assign(device, this, {
      properties: updatedProperties,
    });
  }
}

export default Device;
